import {
    API,
    graphqlOperation
} from "aws-amplify";

import { AuthIDTokenSupplierFactory } from "../../auth/AuthIDTokenSupplierFactory";
import ClientLoggerFactory from "../../logging/ClientLoggerFactory";
import GraphQLUserOrganizationAssociationDAO from "./GraphQLOrganizationAssociationDAO";
import UserOrganizationAssociationDAO from "../UserOrganizationAssociationDAO";

export default class GraphQLUserOrganizationAssociationDAOFactory {
    private static readonly INSTANCE: UserOrganizationAssociationDAO = new GraphQLUserOrganizationAssociationDAO(
        API,
        graphqlOperation,
        ClientLoggerFactory.getClientLogger("GraphQLOrganizationDAO"),
        AuthIDTokenSupplierFactory.getInstance()
    );
    public static getInstance() {
        return this.INSTANCE;
    }
}